import {
  Badge,
  Button,
  Calendar,
  Card,
  Col,
  Row,
  Space,
  Switch,
  Tabs,
  Tag,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { DEVICE } from "common/Device";
import COLORS from "common/Colors";
import moment from "moment";
import { isDateBetweenTwoDates } from "utils/Date";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import { getClientid, getShiftList, getUserInfo } from "redux/selectors";
import { find, get } from "lodash";
import { STATUS_CODE } from "common/Constants";
import isoWeek from "dayjs/plugin/isoWeek";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);
dayjs.extend(isSameOrBefore);

const { TabPane } = Tabs;

const MyShiftWrap = styled.div`

.custom-week-tabs .ant-tabs-nav {
  margin: 0;
  padding: 0 0px;
  background: #f9f9f9;
  border-bottom: 1px solid #e0e0e0;
}

.custom-week-tabs .ant-tabs-tab {
  flex: 1;
  justify-content: center;
  text-align: center;
  font-weight: 500;
  padding: 12px 0;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s;
}

.custom-week-tabs .ant-tabs-tab-active {
  background: #e6eaff;
  color: #1d4ed8;
}

.custom-week-tabs .ant-tabs-ink-bar {
  background: #1d4ed8;
  height: 2px;
}

.custom-week-tabs .ant-tabs-nav-list {
  display: flex;
  width: 100%;
}

.custom-week-tabs .ant-tabs-tab-btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
  .week-box {
    width: 100%;
    padding: 0;
    background: #fafafa;
    cursor: pointer;
    text-align: center;
  }
    .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list{
    display:flex; justify-content: space-between, width:100%}
`;

const StyledAntCalendarFull = styled(Calendar)`
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
    background: #e6f7ff !important;
    margin: 0;
  }
  .ant-picker-content td {
    height: 150px !important; /* key change */
  }

  .ant-picker-calendar-date {
    height: 100% !important; /* make the date box fill the row */
  }

  .ant-picker-calendar-date-content {
    height: calc(100% - 24px) !important; /* leave space for the day number */
    overflow: auto; /* scroll long content if needed */
  }
  background: transparent !important;
  width: 100%;
  .ant-picker-calendar-header {
    display: none;
  }
  .ant-picker-panel {
    background: transparent !important;
  }
  .ant-picker-cell,
  th {
    border: solid 1px #9c9c9c;
    text-align: left;
  }
  th {
    width: 100px;
    padding: 10px !important;
    text-align: center;
    font-weight: bold;
    border-bottom: none;
  }
  th:nth-child(1):after {
    content: "n";
  }
  th:nth-child(2):after {
    content: "n";
  }
  th:nth-child(3):after {
    content: "e";
  }
  th:nth-child(4):after {
    content: "d";
  }
  th:nth-child(5):after {
    content: "u";
  }
  th:nth-child(6):after {
    content: "i";
  }
  th:nth-child(7):after {
    content: "t";
  }
  .ant-picker-cell-in-view {
    color: ${COLORS.BLACK};
  }
  tbody tr:nth-child(1) td {
    border-top: none !important;
  }
  .ant-picker-calendar-full
    .ant-picker-panel
    .ant-picker-calendar-date-content {
    height: 200px;
  }
  .ant-picker-calendar {
    line-height: 1 !important;
  }

  @media ${DEVICE.mobileL} {
    th {
      font-size: 10px;
      font-weight: 500px;
      width: 100% !important;
      text-align: left;
      padding: 0 !important;
    }
  }
`;

const StyledHolidayBadge = styled(Badge)`
  margin-top: 12px;
  margin-left: 20px;
  padding: 5px;
  color: white;
  background: red;
  border-radius: 50%;
  font-size: 9px;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -2px;
  left: 14px;
`;

const StyledDateCell = styled.div`
  padding: 15px 5px 5px 5px;
  .day {
    padding: 6px 5px;
    border-radius: 50px;
    font-size: 0.8rem;
    font-weight: bold;
  }
  .has-pending-leaves {
    background: ${COLORS.PENDING_LEAVE};
    color: ${COLORS.WHITE};
  }
  .hr-leave-container {
    text-align: center;
    padding-top: 50px;
    .ant-badge-count {
      min-width: 30px !important;
      height: 30px !important;
      line-height: 30px !important;
      border-radius: 50px;
      font-size: 14px;
      box-shadow: 0px 1px 5px #6f6f6f;
      font-weight: bold;
    }
    @media (max-width: 935px) {
      .ant-badge-count {
        min-width: 15px !important;
        height: 15px !important;
        line-height: 15px !important;
      }
    }
    @media (max-width: 762px) {
      .ant-badge-count {
        min-width: 30px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
    }
    @media (max-width: 600px) {
      .ant-badge-count {
        min-width: 15px !important;
        height: 15px !important;
        line-height: 15px !important;
      }
    }
    .hr-has-pending-leaves {
      margin-right: 2px;
      .ant-badge-count {
        background: ${COLORS.PENDING_LEAVE};
      }
    }
  }
  .hr-has-approved-leaves {
    margin-left: 3px;
    .ant-badge-count {
      background: ${COLORS.APPROVED_LEAVE};
    }
  }
  @media ${DEVICE.mobileL} {
    padding: 0px;
    height: 100px;
    .hr-leave-container {
      padding-top: 0px;
    }
  }
  .has-approved-leaves {
    background: ${COLORS.APPROVED_LEAVE};
    color: ${COLORS.WHITE};
  }
  .ant-picker-calendar-date-content {
    height: 46px;
    margin-top: 5px;
  }
`;

const MyShift = () => {
  const history = useHistory();
  const userInfo = useSelector(getUserInfo);
  const ClientId = useSelector(getClientid);
  const shiftLists = useSelector(getShiftList);

  const [isMonthly, setIsMonthly] = useState(false);
  const [currentDate, setCurrentDate] = useState(dayjs());

  const [holidayList, setHolidayList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [assignedShiftList, setAssignedShiftList] = useState([]);
  const [shiftList, setShiftList] = useState([]);

  const getShiftLists = async () => {
    try {
      const { data } = await CALL_API(`get-shift/${ClientId}`, "get", {});
      setShiftList(data);
    } catch (error) {
      console.log("[getDepartmentList], Error-->", error);
    }
  };

  const getAssignedShiftList = async () => {
    try {
      const { data } = await CALL_API(
        `get-user-shift/${ClientId}/${userInfo?.userid}`,
        "post",
        {
          from: currentDate.startOf("month").format("MMMM YYYY"),
          to: currentDate.endOf("month").format("YYYY-MM-DD"),
        }
      );
      setAssignedShiftList(data);
    } catch (error) {
      console.log("[getShiftList] Error:", error);
    } finally {
    }
  };

  const handleToggle = (checked) => setIsMonthly(checked);
  const handlePrev = () => setCurrentDate((prev) => prev.subtract(1, "month"));
  const handleNext = () => setCurrentDate((prev) => prev.add(1, "month"));
  const renderDateRange = () =>
    currentDate.startOf("month").format("MMMM YYYY");

  const isValidDateValue = (val) => val && val !== "null" && val !== "";

  const getHolidayList = async () => {
    const baselocationid = userInfo?.baseLocationId;
    const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: currentDate.startOf("month").format("YYYY-MM-DD"),
      end_date: currentDate.endOf("month").format("YYYY-MM-DD"),
    });
    setHolidayList(
      response?.filter((item) => item?.location_id?.includes(baselocationid))
    );
  };

  const getLeaveList = async () => {
    const { code, leaves } = await CALL_API(`leave-list/${ClientId}`, "post", {
      status_id: "4,5",
      department_id: [""],
      selected_role_id: "",
      start_date: currentDate.startOf("month").format("YYYY-MM-DD"),
      end_date: currentDate.endOf("month").format("YYYY-MM-DD"),
      show_my_team_leave: false,
    });
    if (code === STATUS_CODE.SUCCESS) {
      setLeaveList(
        leaves?.filter((val) => val?.userid === get(userInfo, "userid", ""))
      );
    }
  };

  const getEventsForDate = (date) => {
    const dateStr = date.format("YYYY-MM-DD");
    const events = [];
    // Assigned Shifts
    assignedShiftList.forEach((shiftAssignment) => {
      shiftAssignment.dates.forEach((dateObj) => {
        if (dateObj.date === dateStr) {
          const findShift = shiftLists?.find(
            (val) => val?.shift_id === dateObj?.shift_id
          );
          events.push({
            type: "shift",
            content: dateObj.shifttitle,
            color: findShift.color,
            starts: findShift?.starts,
            ends: findShift?.ends,
            isholiday: findShift?.isholiday,
            isweekend: findShift?.isweekend,
            shift_id: findShift?.shift_id,
            shiftcode: findShift?.shiftcode,
          });
        }
      });
    });

    // Leaves
    leaveList.forEach((leave) => {
      const finalStart = isValidDateValue(leave.new_start_date)
        ? leave.new_start_date
        : leave.start_date;
      const finalEnd = isValidDateValue(leave.new_end_date)
        ? leave.new_end_date
        : leave.end_date;

      if (isDateBetweenTwoDates(date, finalStart, finalEnd)) {
        events.push({
          type: "leave",
          content: leave.leave_category_name,
          status_id: leave.status_id,
          isAmended: leave.having_cancel_request,
        });
      }
    });

    return events;
  };

  const dateCellRender = (value) => {
    const events = getEventsForDate(value);
    const isHoliday = find(holidayList, ({ start_date, end_date }) =>
      isDateBetweenTwoDates(value, start_date, end_date)
    );

    const leaveColor = get(isHoliday, "color", "");

    const leaveEvent = events.find((e) => e.type === "leave");
    const shiftEvent = events.find((e) => e.type === "shift");
    const daynumber = dayjs(value).day();

    return (
      <>
        <span className="d-flex">
          {leaveColor && (
            <StyledHolidayBadge size="small" color={"red"}>
              H
            </StyledHolidayBadge>
          )}
          {leaveEvent && (
            <StyledHolidayBadge
              size="small"
              style={{
                background:
                  leaveEvent.status_id === "4" || leaveEvent.isAmended === "1"
                    ? "orange"
                    : leaveEvent.status_id === "5" &&
                      leaveEvent.isAmended === "0"
                    ? "green"
                    : "",
              }}
              color={""}
            />
          )}
        </span>

        {(leaveEvent || shiftEvent) && (
          <StyledDateCell
            className="w-100 p-2 mt-3"
            style={{
              height: "80px",
              background:
                leaveEvent ||
                (shiftEvent?.isweekend === "allsaturdayandsunday" &&
                  (daynumber === 0 || daynumber === 6)) ||
                (shiftEvent?.isweekend === "allsaturdays" && daynumber === 6) ||
                (shiftEvent?.isweekend === "allsundays" && daynumber === 0) ||
                shiftEvent?.isweekend === "alldays" ||
                (isHoliday && shiftEvent?.isholiday === "no")
                  ? ""
                  : shiftEvent?.color,
              borderRadius: "10px",
              border: leaveEvent
                ? leaveEvent.status_id === "4" || leaveEvent.isAmended === "1"
                  ? "1px solid orange"
                  : leaveEvent.status_id === "5" && leaveEvent.isAmended === "0"
                  ? "1px solid green"
                  : ""
                : (shiftEvent?.isweekend === "allsaturdayandsunday" &&
                    (daynumber === 0 || daynumber === 6)) ||
                  (shiftEvent?.isweekend === "allsaturdays" &&
                    daynumber === 6) ||
                  (shiftEvent?.isweekend === "allsundays" && daynumber === 0) ||
                  shiftEvent?.isweekend === "alldays" ||
                  (isHoliday && shiftEvent?.isholiday === "no")
                ? "1px solid gray"
                : "",
            }}
          >
            {leaveEvent ? (
              <>
                <span
                  style={{
                    display: "inline-block",
                    maxWidth: "100%",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    verticalAlign: "middle",
                  }}
                  title={leaveEvent.content} // optional: show full text on hover
                >
                  {leaveEvent.content}
                </span>
                {shiftEvent && (
                  <>
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      {shiftEvent?.shiftcode}{" "}
                    </span>
                    <br></br>
                    <small style={{ fontSize: "10px" }}>
                      ({dayjs(shiftEvent?.starts).format("hh:mm A")} -{" "}
                      {dayjs(shiftEvent?.ends).format("hh:mm A")})
                    </small>
                  </>
                )}
              </>
            ) : isHoliday && shiftEvent?.isholiday === "no" ? (
              <>
                <>
                  {isHoliday?.holiday_name} <br />
                  <small style={{ fontSize: "10px" }}>
                    {shiftEvent?.shiftcode} {""}
                    <br></br>
                    {dayjs(shiftEvent?.starts).format("hh:mm A")} -{" "}
                    {dayjs(shiftEvent?.ends).format("hh:mm A")}
                  </small>
                </>
              </>
            ) : (
              <>
                <>
                  {(shiftEvent?.isweekend === "allsaturdayandsunday" &&
                    (daynumber === 0 || daynumber === 6)) ||
                  (shiftEvent?.isweekend === "allsaturdays" &&
                    daynumber === 6) ||
                  (shiftEvent?.isweekend === "allsundays" && daynumber === 0) ||
                  shiftEvent?.isweekend === "alldays" ? (
                    <>
                      Weekend <br />
                      <small style={{ fontSize: "10px" }}>
                        {shiftEvent?.shiftcode} {""}
                        <br></br>
                        {dayjs(shiftEvent?.starts).format("hh:mm A")} -{" "}
                        {dayjs(shiftEvent?.ends).format("hh:mm A")}
                      </small>
                    </>
                  ) : (
                    <>
                      {shiftEvent?.content} <br />
                      <small style={{ fontSize: "10px" }}>
                        {dayjs(shiftEvent?.starts).format("hh:mm A")} -{" "}
                        {dayjs(shiftEvent?.ends).format("hh:mm A")}
                      </small>
                    </>
                  )}
                </>
              </>
            )}
          </StyledDateCell>
        )}
      </>
    );
  };

  const getMonthWeeks = (currentDate) => {
    const startOfMonth = currentDate.startOf("month");
    const endOfMonth = currentDate.endOf("month");

    const weeks = [];
    let current = startOfMonth.startOf("isoWeek");
    let weekCounter = 1;

    while (current.isBefore(endOfMonth) || current.isSame(endOfMonth, "day")) {
      const start = current.isBefore(startOfMonth) ? startOfMonth : current;
      const end = current.endOf("isoWeek").isAfter(endOfMonth)
        ? endOfMonth
        : current.endOf("isoWeek");

      weeks.push({
        weekLabel: `Week ${weekCounter}`,
        startDate: start,
        endDate: end,
      });

      current = current.add(1, "week");
      weekCounter++;
    }

    return weeks;
  };
  const weeks = useMemo(() => getMonthWeeks(currentDate), [currentDate]);

  const getDaysInRange = (start, end, leaveList, assignedShiftList) => {
    const days = [];
    let current = start.clone();

    while (current.isSameOrBefore(end, "day")) {
      const dateStr = current.format("YYYY-MM-DD");

      const userShift = assignedShiftList?.find((shift) =>
        shift.dates.some((d) => d.date === dateStr)
      );

      const dateShift = userShift?.dates.find((d) => d.date === dateStr);
      const isValidDateValue = (val) => val && val !== "null" && val !== "";
      const leaveMatch = leaveList?.find((leave) => {
        const startDate = isValidDateValue(leave.new_start_date)
          ? leave.new_start_date
          : leave.start_date;

        const endDate = isValidDateValue(leave.new_end_date)
          ? leave.new_end_date
          : leave.end_date;

        return dateStr >= startDate && dateStr <= endDate;
      });

      const holidayMatch = holidayList?.find((holiday) => {
        const startDate = holiday.start_date;

        const endDate = holiday.end_date;

        return dateStr >= startDate && dateStr <= endDate;
      });
      const findShift = shiftList?.find(
        (val) => val?.shift_id === dateShift?.shift_id
      );
      days.push({
        date: current.clone(),
        shiftTitle: dateShift?.shifttitle || "",
        shiftCode: dateShift?.shiftcode || "",
        shiftColor: findShift?.color || "",
        leaveStatus: leaveMatch?.status_id || "",
        leaveName: leaveMatch?.leave_category_name || "",
        isAmended: leaveMatch?.having_cancel_request || "",
        holidayname: holidayMatch?.holiday_name,
        starts: findShift?.starts,
        ends: findShift?.ends,
        isholiday: findShift?.isholiday,
        isweekend: findShift?.isweekend,
        shiftcode: findShift?.shiftcode,
      });

      current = current.add(1, "day");
    }

    return days;
  };
  useEffect(() => {
    getAssignedShiftList();
    getHolidayList();
    getLeaveList();
  }, [currentDate]);

  useEffect(() => {
    getShiftLists();
  }, []);

  return (
    <MyShiftWrap>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <Space>
          <div
            style={{
              background: "#E2E2E8",
              borderRadius: 4,
              padding: "10px",
            }}
          >
            <span>Weekly</span>
            <Switch
              className="mx-2"
              checked={isMonthly}
              onChange={handleToggle}
            />
            <span>Monthly</span>
          </div>
          <div
            className="mx-2"
            style={{
              background: "#E2E2E8",
              borderRadius: 4,
              padding: "10px",
            }}
          >
            <CalendarOutlined className="mx-2" />
            <b>{renderDateRange()}</b>
            <LeftOutlined onClick={handlePrev} className="mx-2" />
            <RightOutlined onClick={handleNext} />
          </div>
        </Space>
        <Space>
          <Button
            type="link"
            className="change-view"
            onClick={() => {
              history?.push("/dashboard");
            }}
          >
            Back to Dashboard
          </Button>
        </Space>
      </div>
      {isMonthly ? (
        <StyledAntCalendarFull
          fullscreen={true}
          dateCellRender={dateCellRender}
        />
      ) : (
        <div>
          <Tabs
            defaultActiveKey={weeks[0].weekLabel}
            className="custom-week-tabs"
          >
            {weeks.map((week) => (
              <TabPane tab={week.weekLabel} key={week.weekLabel}>
                <Row className="mt-3" gutter={[16, 16]}>
                  {getDaysInRange(
                    week.startDate,
                    week.endDate,
                    leaveList,
                    assignedShiftList
                  ).map((dayData) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={dayData.date}>
                      <Card
                        style={{
                          minHeight: "130px",
                          borderRadius: 10,
                          border: "1px solid #e6e6e6",
                          // background: "#e6e6e6",
                        }}
                      >
                        <div style={{ fontWeight: 500 }}>
                          {dayjs(dayData?.date).format("Do")},{" "}
                          {(dayData?.date).format("dddd")}
                        </div>

                        <Tag
                          style={{
                            marginTop: "10px",
                            background:
                              dayData?.leaveStatus ||
                              dayData?.holidayname ||
                              (dayData?.isweekend === "allsaturdayandsunday" &&
                                (dayjs(dayData?.date).day() === 0 ||
                                  dayjs(dayData?.date).day() === 6)) ||
                              (dayData?.isweekend === "allsaturdays" &&
                                dayjs(dayData?.date).day() === 6) ||
                              (dayData?.isweekend === "allsundays" &&
                                dayjs(dayData?.date).day() === 0) ||
                              dayData?.isweekend === "alldays" ||
                              (dayData?.holidayname &&
                                dayData?.isholiday === "no")
                                ? ""
                                : dayData?.shiftColor || "",
                            borderRadius: 8,
                            border:
                              dayData?.leaveStatus === "4" ||
                              dayData?.isAmended === "1"
                                ? "1px solid orange"
                                : dayData?.leaveStatus === "5"
                                ? "1px solid green"
                                : "",
                            padding: "3px 8px",
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                        >
                          {/* Case 1: Leave */}
                          {(dayData?.leaveStatus === "4" ||
                            dayData?.leaveStatus === "5") &&
                          !dayData?.holidayname ? (
                            <span>
                              <Badge
                                className="me-2"
                                color={
                                  dayData?.leaveStatus === "4" ||
                                  dayData?.isAmended === "1"
                                    ? "orange"
                                    : "green"
                                }
                              />
                              {dayData?.leaveName}
                              <br />
                              {dayData?.shiftTitle}{" "}
                              {dayData?.starts && dayData?.starts ? (
                                <>
                                  {dayjs(dayData?.starts).format("hh:mm A")} -{" "}
                                  {dayjs(dayData?.ends).format("hh:mm A")}
                                </>
                              ) : (
                                <></>
                              )}
                            </span>
                          ) : /* Case 2: Holiday */
                          dayData?.holidayname ? (
                            <span>
                              <Badge className="me-2" color="red" count="H" />
                              <span className="mx-2">
                                {dayData?.holidayname}
                              </span>
                              <br />
                              {dayData?.shiftTitle ? (
                                <>
                                  {dayData?.shiftTitle}{" "}
                                  {dayjs(dayData?.starts).format("hh:mm A")} -{" "}
                                  {dayjs(dayData?.ends).format("hh:mm A")}
                                </>
                              ) : (
                                <></>
                              )}
                            </span>
                          ) : /* Case 3: Weekend with shift */
                          ((dayData?.isweekend === "allsaturdayandsunday" &&
                              (dayjs(dayData?.date).day() === 0 ||
                                dayjs(dayData?.date).day() === 6)) ||
                              (dayData?.isweekend === "allsaturdays" &&
                                dayjs(dayData?.date).day() === 6) ||
                              (dayData?.isweekend === "allsundays" &&
                                dayjs(dayData?.date).day() === 0) ||
                              dayData?.isweekend === "alldays") &&
                            dayData?.shiftTitle ? (
                            <span>
                              Weekend
                              <br />
                              {dayData?.shiftcode}{" "}
                              {dayjs(dayData?.starts).format("hh:mm A")} -{" "}
                              {dayjs(dayData?.ends).format("hh:mm A")}
                            </span>
                          ) : /* Case 4: Normal shift or no shift */
                          dayData?.shiftTitle ? (
                            <span>
                              {dayData?.shiftTitle}
                              <br />
                              {dayjs(dayData?.starts).format("hh:mm A")} -{" "}
                              {dayjs(dayData?.ends).format("hh:mm A")}
                            </span>
                          ) : (
                            <span>
                              <p>😴 No Shift Assigned</p>
                            </span>
                          )}
                        </Tag>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </TabPane>
            ))}
          </Tabs>
        </div>
      )}
    </MyShiftWrap>
  );
};

export default MyShift;
